<!-- mettal-3\src\components\View512.vue -->
<template>
  <div :class="[`x3-23`, className || ``]">
    <img
      class="vector-303"
      src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/vector-243.svg"
      alt="Vector"
    />
  </div>
</template>

<script>
export default {
  name: "View512",
  props: ["className"],
};
</script>

<style>
.x3-23 {
  background-color: var(--alto);
  border-radius: 60px;
  height: 40px;
  left: 5px;
  position: absolute;
  top: 101px;
  transform: rotate(90deg);
  width: 40px;
}

.vector-303 {
  height: 60%;
  left: 7.5%;
  position: absolute;
  top: 17.5%;
  width: 85%;
}

.x3-23.view-437,
.x3-23.view-438,
.x3-23.view-439 {
  aspect-ratio: 1;
  background-color: var(--sonic-silver);
  left: unset;
  margin-top: 4px;
  position: relative;
  top: unset;
  transform: unset;
}
</style>
